import { MaskLines, Reveal } from "@/components/site/Reveal";

export const STEPS = [
  ["Book or call", "Pick a time online, request a quote, or give us a ring."],
  ["We assess", "A licensed plumber inspects the job and talks you through the options."],
  ["Clear quote", "You get the price and scope in writing before any work starts."],
  ["Job done right", "Work completed, tested and cleaned up — with a clear report for managers."],
];

export const Process = ({ dark = false }) => (
  <section data-testid="process-section" className={`py-24 sm:py-32 ${dark ? "bg-ink text-white" : "bg-porcelain"}`}>
    <div className="container-x">
      <Reveal><p className={`eyebrow mb-5 ${dark ? "text-brass" : "text-cobalt"}`}>How it works</p></Reveal>
      <h2 className="font-wide font-black uppercase text-4xl sm:text-5xl leading-[0.95] tracking-tight max-w-3xl">
        <MaskLines lines={["Simple from", "first call to clean-up."]} />
      </h2>
      <ol className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map(([t, d], i) => (
          <Reveal as="li" key={t} delay={i * 0.1} className={`relative p-7 border ${dark ? "border-white/15" : "border-ink/15 bg-white"} group hover:-translate-y-1 transition-transform duration-500`}>
            <span className="font-wide font-black text-6xl text-brass/90 leading-none">{i + 1}</span>
            <h3 className="mt-6 font-wide font-extrabold text-xl">{t}</h3>
            <p className={`mt-2 text-sm leading-relaxed ${dark ? "text-slate-300" : "text-slate-600"}`}>{d}</p>
            <span className="absolute left-0 bottom-0 h-[3px] w-0 bg-brass transition-[width] duration-500 group-hover:w-full" />
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
